export const REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS = 'redirect_to_medcard_with_document_mis'
